import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "tailwind-variants";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    return (
        <section className={cn("tw:flex tw:flex-col tw:mb-3")}>
            {children}
        </section>
    );
};

export { Base };
